import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useState } from "react";

const LargeString = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      alignCenter={"No"}
      node={node}
      leftString={text}
      rightComponent={
        <LargeStringInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></LargeStringInput>
      }
    ></SimpleQuestion>
  );
};

const LargeStringInput = ({ node, handleAnswerChange, qfusermode }) => {
  const [input, setInput] = useState(node.answer ? node.answer : "");

  const handleBlur = (event) => {
    if (node.answer != input) handleAnswerChange(input);
  };

  const handleChange = (event) => {
    setInput(event.target.value);
  };
  let widthFromLogic = node.logic.width
    ? `${node.logic.width}vw`
    : theme.inputStyle.width;
  // const dispatch = useDispatch();
  return (
    <textarea
      type="text"
      id={"stringInput" + node.id}
      style={{ ...theme.inputStyle, minHeight: "12vh", width: widthFromLogic }}
      value={input}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={qfusermode === INSURER ? true : false}
      maxLength={node.id === "69000" ? 471 : undefined}
    ></textarea>
  );
};

export default LargeString;
